module.exports = __webpack_public_path__ + "static/media/tutoriales_sgc.4a303add.svg";